package fyi.moko.hotpl.data.service

import fyi.moko.hotpl.domain.service.ChangelogStore
import kotlinx.browser.localStorage
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * `localStorage`-backed [ChangelogStore]. Reads and writes are defensive the same way
 * [JsDestinationHistoryStore]'s are — private browsing or a full quota makes localStorage
 * throw, and losing a reading position must not take the screen down with it.
 */
class JsChangelogStore : ChangelogStore {
    private val _lastSeenVersion = MutableStateFlow(load())
    override val lastSeenVersion = _lastSeenVersion.asStateFlow()

    override suspend fun markSeen(version: String) {
        _lastSeenVersion.value = version
        try {
            localStorage.setItem(KEY, version)
        } catch (e: Throwable) {
            console.error("Failed to persist the seen changelog version to localStorage", e)
        }
    }

    private fun load(): String? = try {
        localStorage.getItem(KEY)
    } catch (e: Throwable) {
        console.error("Failed to read the seen changelog version from localStorage", e)
        null
    }

    private companion object {
        const val KEY = "hotpl_changelog_last_seen_version"
    }
}
